import { useEffect } from 'react';
import { emit, isIncomingEvent } from '../postMessage';
import { runBack } from './backStack';

/**
 * Parent → iframe `{ source: 'repackz-parent', type: 'navigate_back' }`.
 * Always answers with `navigate_back_result`; `handled: false` means the
 * iframe is at its root and the host should run its own back (close the
 * WebView).
 */
export function useNavigateBackListener(): void {
  useEffect(() => {
    function onMessage(e: MessageEvent) {
      if (!isIncomingEvent(e.data) || e.data.type !== 'navigate_back') return;
      emit('navigate_back_result', { handled: runBack() });
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
}
